import { render, staticRenderFns } from "./Company_telework.vue?vue&type=template&id=2a6d4292&scoped=true&lang=pug&"
import script from "./Company_telework.vue?vue&type=script&lang=coffee&"
export * from "./Company_telework.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d4292",
  null
  
)

export default component.exports